import { useEffect, useState } from 'react';

/** Once shown, keep guidance mounted until the conversation/topic changes. */
export default function useChatGuidanceVisibility({
  scopeKey,
  settled,
  hasOlder,
}: {
  scopeKey: string;
  settled: boolean;
  hasOlder: boolean;
}) {
  const [confirmed, setConfirmed] = useState({ scopeKey, visible: false });
  const visible = Boolean(scopeKey) && (
    (confirmed.scopeKey === scopeKey && confirmed.visible) || (settled && !hasOlder)
  );

  useEffect(() => {
    setConfirmed((previous) => {
      return previous.scopeKey === scopeKey && previous.visible === visible
        ? previous : { scopeKey, visible };
    });
  }, [scopeKey, visible]);

  return visible;
}
